import { NgxPermissionsModule } from 'ngx-permissions'
import { RouterModule } from '@angular/router'
import { LngLatPickerComponent } from './lng-lat-picker.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'

@NgModule({
  declarations: [LngLatPickerComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    TranslateModule,
    ContentEditableModule,
  ],
  exports: [LngLatPickerComponent],
})
export class LngLatPickerModule {}
